export const CATEGORY_LEVELS = Object.freeze({
    ROOT: 1,
    TOP: 2,
    SUB: 3,
});

export const CATEGORY_STATUSES = Object.freeze({
    PUBLISHED: 'published',
    HIDDEN: 'hidden',
    ARCHIVED: 'archived',
});
